import { defineStore } from 'pinia';
import { ref } from 'vue';

export const CALENDAR_PRIVACY_STORAGE_KEY = 'mpp.calendar.hideCustomerNames';

function readStored(): boolean {
  try {
    return localStorage.getItem(CALENDAR_PRIVACY_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export const useCalendarPrivacyStore = defineStore('calendarPrivacy', () => {
  const hideCustomerMappings = ref(readStored());

  function setHideCustomerMappings(value: boolean): void {
    hideCustomerMappings.value = value;
    try {
      localStorage.setItem(CALENDAR_PRIVACY_STORAGE_KEY, value ? 'true' : 'false');
    } catch {
      // Privacy mode still applies for this session if storage is unavailable.
    }
  }

  return { hideCustomerMappings, setHideCustomerMappings };
});
